import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section } from './shared';
const rows = [{
  without: 'Invisible en redes: Los brokers digitales te roban la zona.',
  with: 'Autoridad Digital: Sos el referente que los clientes buscan.'
}, {
  without: 'Angustia financiera: No saber si el mes que viene entran clientes nuevos.',
  with: 'Cierres Predecibles: Sistema de prospección funcionando 24/7.'
}, {
  without: 'Viernes perdidos: Limpiando Excels y cargando documentación a mano.',
  with: 'Libertad Real: La IA gestiona el papeleo mientras vos vivís.'
}];
const aiIncludes = ['30 posts redactados con IA para Instagram listos para publicar', 'Bio y perfil optimizado para Instagram', 'Sistema de seguimiento automático de clientes', 'Template de propuesta comercial profesional editable', 'Sistema de referidos en 3 pasos con mensajes listos', 'Guía de especialización por tipo de seguro', 'Mini-Curso "Tu Primera Semana con IA" en video (20 minutos)'];
export function ComparisonAI() {
  return <Section className="bg-white py-16 sm:py-24" data-id="element-28" data-mp="3m91fq8aly4yu">
      <h2 className="text-center font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-29" data-mp="3hddrbv3y9fue">
        🕊️ ¿QUÉ AGREGA EL MEGAPACK PRO + ASISTENTE DE IA?
      </h2>

      <div className="mt-10 overflow-hidden rounded-2xl border border-slate-200" data-id="element-30" data-mp="3qd99ijvxab3x">
        <div className="grid grid-cols-2" data-id="element-31" data-mp="3qb67t2leqtjd">
          <div className="bg-red-50 px-5 py-4 text-center font-display font-bold text-red-700" data-id="element-32" data-mp="8vg994z6zhg8">
            ❌ Sin Sistema
          </div>
          <div className="bg-emerald-50 px-5 py-4 text-center font-display font-bold text-brandgreen" data-id="element-33" data-mp="3ziswynxib3g">
            ✅ Con Sistema
          </div>
        </div>
        {rows.map((r, i) => <div key={i} className="grid grid-cols-2 border-t border-slate-200" data-id="element-34" data-mp="dwdpvd4k03fm" data-mpi={i}>
            <div className="flex items-start gap-2 px-5 py-4 text-sm text-slate-700 sm:text-[15px]" data-id="element-35" data-mp="2jpc114ojvrcw">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-36" data-mp="2foaardcm2pn2" />
              <span data-id="element-37" data-mp="ine8kw3cbcjl">{r.without}</span>
            </div>
            <div className="flex items-start gap-2 border-l border-slate-200 bg-emerald-50/40 px-5 py-4 text-sm text-slate-700 sm:text-[15px]" data-id="element-38" data-mp="nlfrnh0rnbv2">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandgreen" aria-hidden="true" data-id="element-39" data-mp="sjhd28lnzn9p" />
              <span data-id="element-40" data-mp="xkn6y9r29gkt">{r.with}</span>
            </div>
          </div>)}
      </div>

      <div className="mt-10 rounded-2xl border border-gold/40 bg-amber-50/50 p-7 sm:p-9" data-id="element-41" data-mp="11lytu7ijvnpb">
        <h3 className="font-display text-lg font-bold text-navy" data-id="element-42" data-mp="16jia1cyt6ajw">EL ASISTENTE DE IA INCLUYE</h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-43" data-mp="1bagv0puqrwth">
          {aiIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-slate-700" data-id="element-44" data-mp="1gammo610hjbk">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-45" data-mp="1l9g429jf5uh0" />
              <span data-id="element-46" data-mp="1pai58vwwcglm">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}